import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-delete-confirm-dialog',
  templateUrl: './delete-confirm-dialog.component.html',
  styleUrls: ['./delete-confirm-dialog.component.scss']
})
export class DeleteConfirmDigilatFormDialogComponent implements OnInit {

 Value:boolean=false;
  constructor(public dialogRef: MatDialogRef<DeleteConfirmDigilatFormDialogComponent>,
    @Inject(MAT_DIALOG_DATA) private _data: any) { }

  ngOnInit() {
    this.Value = this._data.Value;
  }

  onCloseClick() {
      this.dialogRef.close(false);
  }

  onConfirmDeleteClick() {
      this.dialogRef.close(true);
  }

}
